import axios from "axios";

export const loadAllProductsAPI = (payload) => {
  return axios
    .get(
      `${payload.dataURL}?limit=${payload.pageSize}&categories=[${
        payload.category
      }]&subCategories=[${payload.subCategory}]&countries=[${
        payload.country
      }]&page=${payload.currentPage}&orderBy=${
        payload.sort ? payload.sort.dir : "desc"
      }&status=${payload.status}&orderColumn=${
        payload.sort ? payload.sort.column : "id"
      }&search=${payload.search ?? ""}`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    )
    .then((res) => res.data);
};

export const loadSingleProductAPI = (payload) => {
  return axios
    .get(`/products/${payload.productId}`, {
      headers: {
        Accept: "application/json",
      },
    })
    .then((res) => res.data);
};
